import { z } from 'zod';
import type { FunnelMetrics } from '../funnel/metrics';
import type { LeadQualityTree } from '../funnel/team';
import { yearMonthSchema } from './common';

export const reportQuerySchema = z.object({
  companyId: z.string().uuid(),
  projectId: z.string().uuid().optional(),
  month: yearMonthSchema,
});

export interface LeadQualityReport {
  companyId: string;
  projectId: string | null;
  month: string;
  /**
   * Últimos 12 meses: captaciones, únicos, recontacto y **% de leads contactados** (Lote 5 · H4, P28,
   * api-comercial-embudo-08) = leads captados en el mes con al menos un contacto efectivo ÷ leads captados en el
   * mes. Se cuenta **por lead** (nunca pasa de 100 %), no por gestión: no es el «% contacto efectivo» del Embudo y
   * el ranking (gestiones efectivas ÷ gestiones de contacto). `contactosEfectivos` sigue siendo la cantidad de
   * gestiones efectivas del mes (agregado del embudo).
   */
  monthly: Array<{
    month: string;
    captaciones: number;
    leadsUnicos: number;
    recontacto: number;
    contactosEfectivos: number;
    /** Leads captados en el mes que ya tuvieron un contacto efectivo (por lead). */
    leadsContactados: number;
    /** leadsContactados ÷ leads captados en el mes; null sin captaciones. */
    pctContactados: number | null;
    pctRecontacto: number | null;
  }>;
  tree: LeadQualityTree;
}

export interface DailyReport {
  companyId: string;
  projectId: string | null;
  month: string;
  days: Array<{ date: string; metrics: FunnelMetrics }>;
  totals: FunnelMetrics;
}
